import React, { useState } from "react";
import { Input, FormGroup, Row, Col, CustomInput } from "reactstrap";

const SearchBar = ({ searchTasks, filterTasks, sortTasks }) => {
  const [label, changeLabel] = useState("");
  const [status, changeStatus] = useState("");
  const [val, changeVal] = useState("");
  const [check, toggleCheck] = useState(false);

  const allLabels = [
    "Select Label",
    "All",
    "Personal",
    "Work",
    "Shopping",
    "Others",
  ];

  const allStatus = ["Select Status", "All", "New", "In Progress", "Completed"];

  const filterFunc = async (param, value) => {
    await filterTasks(param, value);
    await searchTasks(val);
    if (param === "label") {
      changeLabel(value);
      changeStatus("Select Status");
    } else {
      changeStatus(value);
      changeLabel("Select Label");
    }
  };

  const sortFunc = async (value) => {
    await sortTasks(value);
    await searchTasks(val);
    toggleCheck(value);
  };

  return (
    <React.Fragment>
      <Row>
        <Col sm={6} className="no-gutters">
          <select
            className="form-control mx-auto mt-1"
            value={label}
            onChange={(e) => {
              filterFunc("label", e.target.value);
            }}
            style={{ width: "95%" }}
          >
            {allLabels.map((label, i) => (
              <option key={i} value={label} style={{ fontSize: "1rem" }}>
                {label}
              </option>
            ))}
          </select>
        </Col>
        <Col sm={6}>
          <select
            className="form-control mx-auto mt-1"
            value={status}
            onChange={(e) => {
              filterFunc("status", e.target.value);
            }}
            style={{ width: "95%" }}
          >
            {allStatus.map((status, i) => (
              <option key={i} value={status} style={{ fontSize: "1rem" }}>
                {status}
              </option>
            ))}
          </select>
        </Col>
      </Row>

      <FormGroup
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
        }}
        className="my-4"
      >
        <CustomInput
          type="switch"
          id="exampleCustomSwitch"
          name="customSwitch"
          label="Due Date Priority"
          value={check}
          onChange={(e) => sortFunc(e.currentTarget.checked)}
        />

        <section
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <Input
            type="text"
            name="search"
            placeholder="Enter Event To Be Searched"
            className="search"
            onChange={(e) => {
              searchTasks(e.target.value);
              changeVal(e.target.value);
            }}
            style={{ border: "none", borderBottom: "1px solid black" }}
          />
          <span
            style={{ fontSize: "1rem" }}
            role="img"
            aria-label="Search EMoji"
          >
            &#x1F50D;{" "}
          </span>
        </section>
      </FormGroup>
    </React.Fragment>
  );
};

export default SearchBar;
